(function() {
    'use strict';
    class ManifestService {
        constructor($q) {
            this.$q = $q;
            this.manifest = null;
        }

        getManifest() {
            let deferred = this.$q.defer();

            if(!this.manifest) {
                const manifestClient = window.miManifestClientV1;

                const currentHostName = window.location.hostname;

                if (manifestClient) {
                    let currentManifestEnvironment;

                    if (currentHostName.indexOf('.com') !== -1) {
                        currentManifestEnvironment = manifestClient.Environments.PRODUCTION;
                    } else {
                        currentManifestEnvironment = manifestClient.Environments.STAGING;
                    }

                    manifestClient.Initializer.initialize(currentManifestEnvironment);

                    manifestClient.ManifestClient.getInstance().then((manifestClientInstance) => {
                        manifestClientInstance.getCurrentManifest().then((manifest) => {
                            this.manifest = manifest;
                            deferred.resolve(manifest);
                        });
                    });
                }
            } else {
                deferred.resolve(this.manifest);
            }

            return deferred.promise;
        }

        getCompanyOverrides() {
            let deferred = this.$q.defer();
            let overrides = {};

            this.getManifest()
                .then(function (manifest) {
                    if(manifest && manifest.company && manifest.company.overrides) {
                        overrides = manifest.company.overrides;
                    }
                })
                .finally(function () {
                    deferred.resolve(overrides);
                });

            return deferred.promise;
        }

        setOverride(overrideName, overrideValue) {
            let deferred = this.$q.defer();

            this.getManifest()
                .then(function (manifest) {
                    if(manifest && manifest.company && manifest.company.overrides) {
                        manifest.company.overrides[overrideName] = overrideValue;
                    }
                });

            return deferred.promise;
        }
    }

    angular
        .module('MW.Influencers.ManifestService', [])
        .service('ManifestService', [
            '$q',
            ManifestService
        ]);
})();